module.exports = __webpack_public_path__ + "static/img/total.260b4d5e.png";